var a = ".gator-breadcrumbs{display:flex;flex-wrap:wrap}";
export { a as default };